var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/macros/product-badge-macros.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["badges"], 
[], 
function (l_badges, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("badges", l_badges);
var t_2 = "";if(env.getFilter("length").call(context, l_badges) > 0) {
frame = frame.push();
var t_5 = l_badges;
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("badge", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "\n\n            ";
var t_7;
t_7 = env.getFilter("replace").call(context, env.getFilter("lower").call(context, runtime.memberLookup((t_6),"type")),"_","-");
frame.set("badgeType", t_7, true);
if(frame.topLevel) {
context.setVariable("badgeType", t_7);
}
if(frame.topLevel) {
context.addExport("badgeType", t_7);
}
t_2 += "\n\n            <p class=\"c-product-badge c-product-badge--";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "badgeType"), env.opts.autoescape);
t_2 += "\" data-qa-badge-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "badgeType"), env.opts.autoescape);
t_2 += ">";
t_2 += runtime.suppressValue((lineno = 8, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_badge-" + "" + runtime.contextOrFrameLookup(context, frame, "badgeType")])), env.opts.autoescape);
t_2 += "</p>\n\n        ";
;
}
}
frame = frame.pop();
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("badgesMacro");
context.setVariable("badgesMacro", macro_t_1);
var macro_t_8 = runtime.makeMacro(
["product"], 
[], 
function (l_product, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("product", l_product);
var t_9 = "";t_9 += "\n    ";
if(runtime.memberLookup((l_product),"webExclusive")) {
t_9 += "<p class=\"c-product-badge c-product-badge--web-exclusive\" data-qa-badge-web-exclusive>";
t_9 += runtime.suppressValue((lineno = 29, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-web-exclusive"])), env.opts.autoescape);
t_9 += "</p>";
;
}
t_9 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
context.addExport("webExclusive");
context.setVariable("webExclusive", macro_t_8);
var macro_t_10 = runtime.makeMacro(
["urbnBrand"], 
[], 
function (l_urbnBrand, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("urbnBrand", l_urbnBrand);
var t_11 = "";t_11 += "\n    <p class=\"c-product-badge c-product-badge--";
t_11 += runtime.suppressValue(l_urbnBrand, env.opts.autoescape);
t_11 += "-exclusive\" data-qa-badge-";
t_11 += runtime.suppressValue(l_urbnBrand, env.opts.autoescape);
t_11 += "-exclusive>";
t_11 += runtime.suppressValue((lineno = 45, colno = 108, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-" + "" + l_urbnBrand + "" + "-exclusive"])), env.opts.autoescape);
t_11 += "</p>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
context.addExport("brandExclusive");
context.setVariable("brandExclusive", macro_t_10);
var macro_t_12 = runtime.makeMacro(
["productTile"], 
[], 
function (l_productTile, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("productTile", l_productTile);
var t_13 = "";t_13 += "\n    ";
var t_14;
t_14 = runtime.memberLookup((l_productTile),"browseCallOutPrimary");
frame.set("callout", t_14, true);
if(frame.topLevel) {
context.setVariable("callout", t_14);
}
if(frame.topLevel) {
context.addExport("callout", t_14);
}
t_13 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "callout")) {
t_13 += "<p class=\"c-product-badge c-product-badge--call-out-text-primary\" data-qa-bco-primary>";
t_13 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "callout"), env.opts.autoescape);
t_13 += "</p>";
;
}
t_13 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
context.addExport("browseCallOutPrimary");
context.setVariable("browseCallOutPrimary", macro_t_12);
var macro_t_15 = runtime.makeMacro(
["productTile"], 
[], 
function (l_productTile, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("productTile", l_productTile);
var t_16 = "";t_16 += "\n    ";
var t_17;
t_17 = runtime.memberLookup((l_productTile),"browseCallOutSecondary");
frame.set("callout", t_17, true);
if(frame.topLevel) {
context.setVariable("callout", t_17);
}
if(frame.topLevel) {
context.addExport("callout", t_17);
}
t_16 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "callout")) {
t_16 += "<p class=\"c-product-badge c-product-badge--call-out-text-secondary\" data-qa-bco-secondary>";
t_16 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "callout"), env.opts.autoescape);
t_16 += "</p>";
;
}
t_16 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
context.addExport("browseCallOutSecondary");
context.setVariable("browseCallOutSecondary", macro_t_15);
var macro_t_18 = runtime.makeMacro(
["product"], 
[], 
function (l_product, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("product", l_product);
var t_19 = "";t_19 += "\n    ";
if(runtime.memberLookup((l_product),"pdpCallOutTextPrimary")) {
t_19 += "<p class=\"c-product-badge c-product-badge--call-out-text-primary\" data-qa-pco-primary>";
t_19 += runtime.suppressValue(runtime.memberLookup((l_product),"pdpCallOutTextPrimary"), env.opts.autoescape);
t_19 += "</p>";
;
}
t_19 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("pdpCallOutTextPrimary");
context.setVariable("pdpCallOutTextPrimary", macro_t_18);
var macro_t_20 = runtime.makeMacro(
["product"], 
[], 
function (l_product, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("product", l_product);
var t_21 = "";t_21 += "\n    ";
if(runtime.memberLookup((l_product),"pdpCallOutTextSecondary")) {
t_21 += "<p class=\"c-product-badge c-product-badge--call-out-text-secondary\" data-qa-pco-secondary>";
t_21 += runtime.suppressValue(runtime.memberLookup((l_product),"pdpCallOutTextSecondary"), env.opts.autoescape);
t_21 += "</p>";
;
}
t_21 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
context.addExport("pdpCallOutTextSecondary");
context.setVariable("pdpCallOutTextSecondary", macro_t_20);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/macros/product-badge-macros.j2"] , dependencies)